import * as React from "react";
const SvgUserManagementIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 149 149"
    {...props}
  >
    <circle cx={74.5} cy={74.5} r={72.5} stroke="#FFA100" strokeWidth={4} />
    <path
      stroke="#FFA100"
      strokeMiterlimit={10}
      strokeWidth={4}
      d="M75.044 101.953c4.322 0 7.826-3.472 7.826-7.754s-3.504-7.754-7.826-7.754c-4.323 0-7.826 3.472-7.826 7.754s3.503 7.754 7.826 7.754Z"
    />
    <path
      stroke="#FFA100"
      strokeMiterlimit={10}
      strokeWidth={4}
      d="M63.305 113.583c0-3.078 1.235-6.03 3.435-8.21 2.2-2.18 5.187-3.41 8.304-3.42 3.117.01 6.103 1.24 8.303 3.42a11.555 11.555 0 0 1 3.436 8.21M106.348 101.953c4.322 0 7.826-3.472 7.826-7.754s-3.504-7.754-7.826-7.754c-4.322 0-7.826 3.472-7.826 7.754s3.504 7.754 7.826 7.754Z"
    />
    <path
      stroke="#FFA100"
      strokeMiterlimit={10}
      strokeWidth={4}
      d="M94.608 113.583c0-3.085 1.24-6.043 3.444-8.224a11.827 11.827 0 0 1 8.316-3.406c3.112.01 6.092 1.24 8.289 3.42a11.567 11.567 0 0 1 3.429 8.21M43.739 101.953c4.322 0 7.826-3.472 7.826-7.754s-3.504-7.754-7.826-7.754c-4.322 0-7.826 3.472-7.826 7.754s3.504 7.754 7.826 7.754Z"
    />
    <path
      stroke="#FFA100"
      strokeMiterlimit={10}
      strokeWidth={4}
      d="M32 113.583c0-3.078 1.233-6.03 3.43-8.21a11.822 11.822 0 0 1 8.289-3.42c3.118 0 6.11 1.225 8.315 3.406a11.565 11.565 0 0 1 3.444 8.224M43.74 74.815V59.308h62.608v15.507M75.043 74.815V47.677M75.044 47.678c6.483 0 11.739-5.207 11.739-11.63 0-6.424-5.256-11.631-11.74-11.631-6.483 0-11.738 5.207-11.738 11.63 0 6.424 5.256 11.63 11.739 11.63Z"
    />
  </svg>
);
export default SvgUserManagementIcon;
